import { Input, Label } from "reactstrap";
import { CHECKBOX_DATA } from "../../../../Data/JobSearch";

const FilterCheckBox = () => {
  return (
    <div className="checkbox-animated">
      {CHECKBOX_DATA.map((data, index) => (
        <Label className="d-block" for={`chk-ani-${index}`} key={index} check>
          <Input
            className="checkbox_animated"
            id={`chk-ani-${index}`}
            type="checkbox"
          />
          {data.inputTittle} {data.inputNumber}
        </Label>
      ))}
    </div>
  );
};

export default FilterCheckBox;
